import { log } from "~features/seated-reservation/helpers/stateLogger";
import { initialState, setState } from "../index";

export const resetState = () => {
  log("resetState");

  return setState(initialState);
};
